import axios from 'axios'
import qs from 'qs'
import {
    baseURL,
    contentType,
    requestTimeout,
    successCode
} from '@/config'
import { isArray } from '@/utils/validate'

const handleCode = (code, msg) => {
    console.log(code + ':' + msg);
}

const instance = axios.create({
    baseURL: baseURL,
    timeout: requestTimeout,
    headers: {
        'Content-Type': contentType,
    },
})

instance.interceptors.request.use(
    (config) => {
        if (config.data && config.headers['Content-Type'] === 'application/x-www-form-urlencoded;charset=UTF-8')
            config.data = qs.stringify(config.data)

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

instance.interceptors.response.use(
    (response) => {
        const { data, config } = response

        if (config.reqType == 'html') {
            return data;
        } else {
            const { code, msg } = data

            const codeVerificationArray = isArray(successCode)
                ? [...successCode]
                : [...[successCode]]

            if (codeVerificationArray.includes(code)) {
                return data
            } else {
                handleCode(code, msg)
                return Promise.reject(data)
            }
        }
    },
    (error) => {
        const { response, message } = error
        if (error.response && error.response.data) {
            const { status, data } = response
            handleCode(status, data.msg || message)
            return Promise.reject(error)
        } else {
            let { message } = error
            if (message === 'Network Error') {
                message = '后端接口连接异常'
            }
            if (message.includes('timeout')) {
                message = '后端接口请求超时'
            }
            if (message.includes('Request failed with status code')) {
                const code = message.substr(message.length - 3)
                message = '后端接口' + code + '异常'
            }
            return Promise.reject(error)
        }
    }
)

export default instance
